import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'

import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

export const appSansthaLogin = createAsyncThunk('appHub/appSansthaLogin', async params => {
	try {
		const response = await httpService.post('/auth/sendotpteam', {}, params)

		if (response?.data.data.success === false) {
			toast.error(response.data.data.message || 'Login failed')
		}
		if (response.data) {
			response.data.navigate = params.navigate
		}
		return await response.data.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appSansthaLoginOtp = createAsyncThunk('appHub/appSansthaLoginOtp', async params => {
	try {
		const response = await httpService.post('/auth/verifyotpteam', {}, params)

		const user = response?.data?.data?.user || {}
		const token = response?.data?.data?.token

		localStorage.setItem('sansthaAdmin', JSON.stringify(user))

		let navigateTo = '/'

		// ==========================
		// ✅ 1. ADMIN LOGIC (UNCHANGED)
		// ==========================
		if (user?.adminOfSanstha?.length > 0 && token) {
			navigateTo = '/dashboard'
		}

		// ==========================
		// ✅ 2. PERMISSION BASED SANSTHA LOGIC
		// ==========================
		else if (user?.permissionOfSanstha?.length > 0) {
			const firstSanstha = user.permissionOfSanstha[0]
			const permissionNames = firstSanstha?.permissions?.map(p => p.name) || []

			if (permissionNames.length > 0) {
				navigateTo = `/${permissionNames[0]}`
			}
		}

		params.navigate(navigateTo)

		return { data: response.data, navigate: params.navigate }
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appHubAdminSlice = createSlice({
	name: 'Hub',
	initialState: {
		HubAdmin: '',
		Hub: '',
		userType: [],
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appSansthaLogin.fulfilled), (state, action) => {
			state.Hub = action.payload.data
		})

		builder.addMatcher(isAllOf(appSansthaLoginOtp.fulfilled), (state, action) => {
			state.HubAdmin = action.payload?.data

			const user = action.payload?.data?.data?.user || {}
			const token = action.payload?.data?.data?.token

			if (!token) return

			localStorage.setItem('token', token)
			localStorage.setItem('user', JSON.stringify(user))
			localStorage.setItem('hubId', user?.adminOfHubs || '')
			localStorage.setItem('permissionOfHub', user?.permissionOfHub || '')

			const adminSansthaId = user?.adminOfSanstha?.[0]?.sanstha || ''

			const permissionOfSanstha = user?.permissionOfSanstha || []

			if (adminSansthaId) {
				localStorage.setItem('sansthaId', adminSansthaId)
				localStorage.setItem('permissionOfSanstha', JSON.stringify([]))
				localStorage.setItem('permissions', '')

				action.payload.navigate('/dashboard')
				return
			}

			if (permissionOfSanstha.length > 0) {
				const firstSanstha = permissionOfSanstha[0]
				const firstSansthaId = firstSanstha?.sanstha

				const permissionNames = firstSanstha?.permissions?.map(p => p.name) || []

				state.userType = permissionNames

				localStorage.setItem('sansthaId', firstSansthaId)

				localStorage.setItem('permissionOfSanstha', JSON.stringify(permissionOfSanstha))

				localStorage.setItem('permissions', permissionNames.join(','))

				if (permissionNames.length > 0) {
					action.payload.navigate(`/${permissionNames[0]}`)
				} else {
					action.payload.navigate('/')
				}

				return
			}

			toast.error('You do not have access to this portal.')
			action.payload.navigate('/')
		})
	},
})

export default appHubAdminSlice.reducer
